<template>
  <div class="save-fixed-btn">
    <div v-if="myTimesheetPage">
      <button v-on:click="toCheckin" class="button is-success" v-if="(timesheetStatus.status === statusList.notSubmit && isMyTimesheet) || timesheetStatus.status === statusList.reject || (timesheetStatus.status === statusList.pending && isAdmin)">
        <span>Check in</span>
      </button>
      <button v-on:click="toCheckout" class="button is-warning" v-if="(timesheetStatus.status === statusList.notSubmit && isMyTimesheet) || timesheetStatus.status === statusList.reject || (timesheetStatus.status === statusList.pending && isAdmin)">
        <span>Check out</span>
      </button>
      <button v-on:click="toPreview" class="button is-info">
        <i class="fa fa-eye"></i><span> Preview</span>
      </button>
      <button v-on:click="saveTimesheet" class="button is-danger" v-if="(timesheetStatus.status === statusList.notSubmit && isMyTimesheet) || timesheetStatus.status === statusList.reject || (timesheetStatus.status === statusList.pending && isAdmin)">
        <i class="fa fa-floppy-o"></i><span> Save</span>
      </button>
    </div>
    <div v-if="previewTimesheetPage">
      <div v-if="isMyTimesheet && (timesheetStatus.status === statusList.notSubmit || timesheetStatus.status === statusList.reject)">
        <button @click="submitTimesheet" type="button" class="button is-primary">Submit</button>
      </div>
      <div v-if="isAdmin && timesheetStatus.status === statusList.pending">
        <button @click="approveTimesheet" type="button" class="button is-success">Approve</button>
        <button @click="rejectTimesheet" type="button" class="button is-danger">Reject</button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import Global from '../../services/globalservice'
import { mapGetters } from 'vuex'

export default {
  data () {
    return this.$store.state.pkg
  },
  computed: {
    ...mapGetters({
      timesheet: 'timesheetStatus'
    }),
    timesheetStatus: function () {
      return this.timesheet ? this.timesheet : { status: null }
    },
    statusList: function () {
      return {
        notSubmit: null,
        approved: 1,
        reject: 2,
        pending: 0
      }
    },
    myTimesheetPage: function () {
      return this.$route.name === 'My Timesheet'
    },
    previewTimesheetPage: function () {
      return this.$route.name === 'Preview Timesheet'
    },
    isAdmin: function () {
      let userProfile = JSON.parse(window.localStorage.getItem('user_profile'))
      return userProfile.user_role.role_id === Global.ROLE.ADMIN
    },
    isMyTimesheet: function () {
      let userProfile = JSON.parse(window.localStorage.getItem('user_profile'))
      return userProfile.id === Number(this.$route.params.id)
    }
  },
  methods: {
    saveTimesheet: function () {
      $('body').trigger('timesheet')
    },

    toPreview: function () {
      $('body').trigger('preview')
    },

    toCheckin: function () {
      $('body').trigger('checkin')
    },

    toCheckout: function() {
      $('body').trigger('checkout')
    },

    submitTimesheet: function () {
      this.$events.fire('submit-timesheet')
    },

    approveTimesheet: function () {
      this.$events.fire('approve-timesheet')
    },

    rejectTimesheet: function () {
      this.$events.fire('reject-timesheet')
    }
  }

}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/mixins';

.footer {
  margin-left: 180px;

  @include mobile() {
    margin-left: 0;
  }

  .social a {
    border-bottom: none !important;
  }

  .fa.fa-heart {
    color: red;
  }
}

.save-fixed-btn {
  position: fixed !important;
  right: 1%;
  bottom: 1%;
}
</style>



// WEBPACK FOOTER //
// FooterBar.vue?0f44662b